<template>
    <!-- <div id="menu">
      <v-treeview activatable dense hoverable :items="items">
        <template slot="label" slot-scope="props">
          <router-link :to="{ name: props.item.to }" v-if="props.item.to">{{
            props.item.name
          }}</router-link>
          <span v-else>{{ props.item.name }}</span>
        </template>
      </v-treeview>
    </div> -->
    <div class="pt-4">
      <h1 class="mb-1">Quick Access</h1>
      <v-row class="pl-2">
        <v-col
          v-for="item in items"
          :key="item.id"
          cols="6"
          class="text-center d-flex justify-center"
        >
          <v-card class="pa-2" flat elevation="0" @click="$router.push({ name: item.to })" style="cursor: pointer; width: 200px;">
            <v-img :src="item.img" height="80" contain max-height="80" max-width="80" class="mb-2"></v-img>
            <div>{{ item.name }}</div>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        items: [
        { id: 1, name: "Performance & KPI", to: "selfserviceperformance", img: require('@/assets/performancekpilogo.png') },
        // { id: 2, name: "Attendance", to: "", img: require('@/assets/attendancelogo.png') },
        ]
      };
    },
  
    methods: {

    },
  };
  </script>
  
  <style lang="scss" scoped>
  </style>
  